module.exports = __webpack_public_path__ + "static/img/visual_title_m.954810f.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/concierge/images/visual_title_m.png
// module id = vvIX
// module chunks = 0